<template>
	<transition name="fade" appear>
		<component :is="$route.meta.theme">
			<slot />
		</component>
	</transition>
</template>

<script>
/**
 * Use div tag to avoid break component's layout.
 * Reference to the component [CarouselWrap]
 */
export default {
	name: 'AppLayout',
};
</script>

<style scoped></style>
